import React from "react";

const ReadMoreMurray = () => {
  return (
    <div>
      <div>
        <p className="mb-2">
        We conducted an interview with Professor Murray Brian McBride from Cornell University. 
        Our initial inquiry was directed at understanding the process by which cadmium is absorbed 
        by plants and subsequently enters the food chain. He rexplained that 
        cadmium is taken up from the soil solution into plant roots. Cadmium uptake depends on 
        various factors, including the plant species, soil properties like pH and organic matter 
        content, and the total cadmium present in the soil. Certain plants, such as lettuce and 
        greens like arugula, are more prone to cadmium uptake. Cadmium chemistry in the soil is 
        influenced by total cadmium, pH, and organic matter content.
        </p>
      <p className="mb-2">
        Unfortunately, cadmium toxicity to plants is relatively low, and visible effects are only 
        observed at higher concentrations, such as around 100 parts per million (PPM) in plant tissue. 
        <div className="cursiveText">"So, that makes it dangerous. You could have a situation where the plants look perfectly 
        healthy and the cadmium could be high. In reality though, in the real world, cadmium pollution 
        usually is accompanied by zinc pollution. Not always. We took hundreds and hundreds of soils in 
        the New York City area and analysed them for all of these heavy metals and the zinc-cadmium 
        correlation was quite high. You could almost predict the cadmium level based on the zinc level. 
        Zinc on the other hand is at a much higher concentration in almost every case, upwards of thousands 
        of parts per million in the soil. Then at that level, of course, it's damaging the plants. You can 
        see the effects. I guess you could argue to some extent there's some protection there maybe. I mean, 
        that's not a very good protection, but at least the plants look sickly.”</div> Cadmium contamination alone 
        in plants is not visibly evident, making testing necessary to detect contamination. 
        </p>
      <p className="mb-2">
        Subsequently, we asked if there was a method to cleanse contaminated plants. He provided his response 
        by stating that while it's not difficult to remove cadmium from plant tissue, the process would destroy 
        the plant in the case of greens. Extracting cadmium from grains could be more feasible, potentially 
        chemically extracting it, though such practices have not been commonly implemented.
        When asked if certain types of agriculture are more affected he stated that certain types of agriculture, 
        like using phosphate fertilizers, can lead to higher cadmium concentrations in soil. 
        <div className="cursiveText">“The phosphates that are mined to make these fertilizers, some of them are mined in areas where the phosphates’ 
        rock is unusually high in cadmium. The chemistry of metals like zinc and cadmium is such that they tend 
        to accumulate in the phosphate. Cadmium ends up in the phosphates sometimes in hundreds of parts per million.
        When they process this rock to make it more soluble, most cadmium remains in the final product. So, 
        depending on where the farmers get the phosphates it could add substantial cadmium to the soil.”</div>
        He continued by telling us that there are no strict regulations in the US for cadmium levels in crops, 
        but there are guidelines. Cadmium concentrations in soil are managed to be as low as possible, but exceeding 
        the guidelines doesn't result in penalties. <div className="cursiveText">“For example, some of the lettuce grown in California is grown 
        in black shale soils formed from black shale rock that contains a number of heavy metals including cadmium. 
        So, some of the crops are still high in cadmium in they are grown in that part of California.”</div>
        </p>
      <p className="mb-2">
        When asked about bioavailability once ingested he told us that cadmium in plants is highly bioavailable when 
        ingested by humans and animals. While risk assessors assume 100% bioavailability, the actual bioavailability 
        might vary.
        </p>
      <p className="mb-2">
        We concluded the interview with two additional inquiries. The first focused on whether methods exist for 
        remediating soil in contaminated areas and whether these techniques are applied in agriculture. We also inquired 
        about the timeframes associated with these processes. The second question pertained to the potential applicability 
        of our project in heavily polluted areas as a temporary measure while awaiting soil decontamination.
        </p>
      <p className="mb-2">
        His answer was that phytoremediation, for cadmium, shows some potential but is often not practical due to the time 
        it takes. Cadmium extraction from soil could take decades to lower concentrations. While some methods. like using 
        chelating agents, can solubilize cadmium, they might have negative environmental impacts or harm the soil's fertility. 
        <div className="cursiveText">“You could use chelating agents which will complex the cadmium in soluble form and move it out the soil that way but 
        then it would leach into groundwater and the chelating agent is also going to strip out a lot of elements that you need 
        in the soil for it to be fertile. So, you would be destroying the soil. It has been done experimentally, but I cannot 
        say that it has been done in a practical way. So that is really not an option either.”</div>
        </p>
      <p className="mb-2">
        Regarding our project, he expressed that while the project's efficiency might depend on human digestion and kinetics, 
        he found the concept intriguing. He suggested that the project could be relevant in regions afflicted by significant 
        cadmium contamination, offering a potential solution during the interim period of soil decontamination. He also noted 
        that the distinct bacterium employed in the project might find utility beyond this context.
        </p>
      <p className="mb-2">
        Overall, the interview with Professor Murray McBride provided insights into the complex issue of cadmium contamination,
        its effects on plants and the food chain, and potential strategies for mitigation.
        </p>

      </div>
    </div>
  );
};

export default ReadMoreMurray;
